const Form080EN = {
    stepName: {
        importantNotes: "Important Notes",
        studentInfo: "Student Information",
        schoolUse: "School Information",
        confirmation: "Confirmation",
    },
    title: {
        t1: "Form Fields requiring user input",
        t2: "For School Use Only",
    },
    studentName: "Name of Student",
    schoolName: "Name of School",
    schoolCode: "SCRN",
    class: "Class",
    birthDate: "Date of Birth",
    address: "Address",
    tel: "Tel",
    strN: "STRN",
    certificate: "HKID/Birth Certificate/Passport No.",
    noOption: {
        hkId: "HKID No.",
        birthNo: "Birth Certificate No.",
        passNo: "Passport No.",
    },
    employName: "Name of Employer",
    employAddress: "Address of Employer",
    workNature: "Nature of work",
    workDate: "Date of work",
    workHours: "Hours of work",
    aPOption: {
        am: "am",
        pm: "pm",
    },
    wages: "Wages",
    workSchedule: "Relevant supporting documents (e.g.  schedule of work)",
    date: "Date",

    validCertify: "School attendance certificate valid",
    schoolTel: "Tel No.",
    schoolAddress: "Address of School",
    classHours: "School Hours",
    schoolChop: "School Chop",

    from: "from",
    to: "to",
    nameOfSchoolHead: "Name of Head of School",
    attachment: "Signature of Head of School Attachment (Scanned signature)",
    sign: {
        parentSign: "Signature of Parent/Guardian “iAM Smart+” signature",
        parentAtt:
            "Signature of Parent/Guardian Attachment (Scanned signature)",
        parentEle: "Signature of Parent/Guardian Electronic signature",
        parentName: "Name of Parent/Guardian",

        headSign: "Signature of Head of School “iAM Smart+” signature",
        headAtt: "Signature of Head of School Attachment (Scanned signature)",
        headEle: "Signature of Head of School Electronic signature",
        headName: "Name of Head of School",
    },

    notes: {
        note: "I have read, understood and agreed to the above terms and conditions.",
        n1: ".",
        n2: "I wish to apply for a school attendance certificate in respect of my child/ward so that he/she may work outside school hours. The particulars of his/her job are as follows:-",
        n3: "I understand that the application form and the school attendance certificate are free of charge.",
        n4: "To : Secretary for Education",
        n5: "[Attn: Non-attendance Cases Team]",
        n6: "Fax: 25200073",
        n7: "I confirm that the personal particulars of the student are correct and that the student's attendance in school has been satisfactory. As far as I can judge, his/her education will not be affected by the employment stated above.",
        n8: "I intend to issue to the parent/guardian a school attendance certificate, which should be valid from",
        n9: ". Grateful if you would send me the certificate for issuance.",
        n10: "to",
    },
    wantSubmit: {
        w1: "I want to submit this application form",
    },
    showPop:
        "Student has already reached 15. According to the Employment Ordinance, application is not applicable.",

    schoolOption: {
        s1: "1",
        s2: "2",
    },

    errorMsg: { minDigit: "This field need at least {{min}} digits" },
};
export default Form080EN;
